import { useParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import CategoryHeader from './components/CategoryHeader';
import ArticleGrid from './components/ArticleGrid';
import CategoryCTASection from './components/CategoryCTASection';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const currentSlug = slug || 'hot';

  return (
    <>
      <Navbar />
      <main>
        <CategoryHeader slug={currentSlug} />
        <ArticleGrid slug={currentSlug} />
        <CategoryCTASection slug={currentSlug} />
      </main>
      <Footer />
    </>
  );
}